import { CommonModule } from '@angular/common'
import { NgModule, Type } from '@angular/core'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { DelonACLModule } from '@delon/acl'
import { DelonFormModule } from '@delon/form'
import { AlainThemeModule } from '@delon/theme'
import { EditorModule } from '@tinymce/tinymce-angular'
import { CanActivateGuard } from '@utils/CanActivateGuard'
import { CanDeactivateGuard } from '@utils/CanDeactivateGuard'

import { DraggableDirective } from './directives/draggable.directive'
import { DynamicComponentDirective } from './directives/dynamic.component.directive'
import { ExtraDataDirective } from './directives/extradata.directive'
import { HighlightDirective } from './directives/highlight.directive'
import { SelectOnFocusDirective } from './directives/select.onfocus.directive'
import { RemoveCommaPipe } from './pipe/remove-comma'
import { ToThousandsPipe } from './pipe/to-thousands'
import { SHARED_DELON_MODULES } from './shared-delon.module'
import { SHARED_ZORRO_MODULES } from './shared-zorro.module'

// #region third libs

const THIRDMODULES: Array<Type<void>> = []

// #endregion

// #region your componets & directives
const COMPONENTS: Array<Type<void>> = []
const DIRECTIVES: Array<Type<void>> = [
  DraggableDirective,
  DynamicComponentDirective,
  HighlightDirective,
  SelectOnFocusDirective,
  ExtraDataDirective,
  ToThousandsPipe,
  RemoveCommaPipe,
]

// #endregion

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonACLModule,
    DelonFormModule,
    EditorModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    // third libs
    ...THIRDMODULES,
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonACLModule,
    DelonFormModule,
    EditorModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
  ],
  providers: [CanDeactivateGuard, CanActivateGuard],
})
export class SharedModule {}
